import React from 'react'
import { Provider } from 'react-redux'
import PropTypes from 'prop-types'
import configureStore from '../store/configureStore'
import App from '../components/App'

const store = configureStore()

const Root = () => (
  <Provider store={store}>
    <App />
  </Provider>
)

Root.propTypes = {
  store: PropTypes.object,
}

export default Root



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Root.js